import { render, staticRenderFns } from "./LearningUnitProgressTableItem.vue?vue&type=template&id=c5644d86&scoped=true&"
import script from "./LearningUnitProgressTableItem.vue?vue&type=script&lang=ts&"
export * from "./LearningUnitProgressTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./LearningUnitProgressTableItem.vue?vue&type=style&index=0&id=c5644d86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5644d86",
  null
  
)

export default component.exports